<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <br />
      <div><h3>複製此分店所有設定至其他店家</h3></div>
      <br />
      <div v-if="getRoleType !== 10" class="text-left">
        <h5>套用門市</h5>
        <div
          v-for="(storeClass, index) in storeClassList" class="m-r-5 m-b-10 inline-block"
          :key="`storeClass-${index}`"
        >
          <button
            class="btn btn-default"
            :class="{'active': curId === storeClass.id}"
            @click="clickOption(storeClass)"
          >
            {{storeClass.name}}
          </button>
        </div>
      </div>
      <div>
        <h5 class="text-left">參與店家</h5>
        <!-- 參與店家 -->
        <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
      </div>
    </div>
    <div class="box-footer text-center">
      <button @click="$router.go(-1)" class="btn btn-default">
        取消
      </button>
      <button class="btn btn-success" @click="copySetting">
        確定
      </button>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      storeBrief: [],
      addStoresSetting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      storeClassList: [],
      curId: 0,
      reNew: 0,
      reSet: 0
    }
  },
  methods: {
    getStoreBrief () {
      console.log('getStoreBrief | CopyStoreTemp')
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.getStoreClassList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj)
              self.addStoresSetting.options.push(obj)
            }
          }
          self.reNew++
        }
      })
    },
    getStoreClassList () {
      if (this.getRoleType === 10) return
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/storeClassList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          self.storeClassList = sList
        }
      })
    },
    async copySetting () {
      // 店家 ID 陣列
      const data = {
        store_id_list: this.addStoresSetting.choose
      }
      // 同步多門市
      if (this.$route.name.includes('ProductSetting')) {
        await this.productAliasStoreSync(data)
        await this.productDescriptionStoreSync(data)
        this.$router.push({ path: '/storeTable/productSetting/' + this.$route.params.brand_id })
      } else if (this.$route.name.includes('ProductImage')) {
        await this.productImageStoreSync(data)
        this.$router.push({ path: '/storeTable/productImage/' + this.$route.params.brand_id })
      }
    },
    async productAliasStoreSync (data) {
      // 同步多門市商品別名設定
      const self = this
      const url = `/store/${this.$route.params.store_id}/productAliasSetting/storeSync`
      await this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '複製門市別名成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    async productDescriptionStoreSync (data) {
      // 同步多門市商品描述設定
      const self = this
      const url = `/store/${this.$route.params.store_id}/productDescriptionSetting/storeSync`
      await this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '複製門市描述成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    async productImageStoreSync (data) {
      // 同步多門市商品圖片設定
      const self = this
      const url = `/store/${this.$route.params.store_id}/productImageSetting/storeSync`
      await this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '複製門市圖片成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var url = 'brand/' + this.$route.params.brand_id + '/storeClass/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach((s) => {
            if (s.id !== parseInt(this.$route.params.store_id, 10)) {
              this.addStoresSetting.choose.push(s.id)
            }
          })
        }
      })
    }
  },
  created () {
    this.getStoreBrief()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyStoreTemp.vue?bfdfc096